export default "__VITE_ASSET__2ef5fcae__"